import { API_URL, IS_SERVER } from "@/misc/constants";
import { get } from "./index";
import { specsCache } from "@/misc/httpCache";
import type {
  tAggrTasks1QueryArgs,
  tAnyTask,
  tBookingScreenQueryRes,
  tDaySlotsBucket,
  tProfessionSpecsQueryArgs,
  tProfessionSpecsQueryRes,
  tSchedulerQueryArgs,
  tSchedulerQueryRes,
  tTaskEditorQueryRes,
  tTaskPayoutScreenQueryRes,
} from "@/types";

const BASE = API_URL + "/query";

const scheduler = async (
  mode: "master" | "saloon",
  { includeIntersected = true, ...params }: tSchedulerQueryArgs,
): Promise<tSchedulerQueryRes> => {
  const url =
    mode === "saloon" ? BASE + "/saloonScheduler" : BASE + "/scheduler";
  const {
    data: { slots, ...rest },
  } = await get<{
    slots: tDaySlotsBucket[];
    tasks: tAnyTask[];
  }>(url, {
    cache: false,
    params: { ...params, includeIntersected },
  });
  return {
    buckets: slots.reduce(
      (acc, bucket) => {
        acc[bucket.date] = bucket;
        return acc;
      },
      {} as tSchedulerQueryRes["buckets"],
    ),
    ...rest,
  };
};

const professionSpecs = async (params: tProfessionSpecsQueryArgs) => {
  const { data } = await get<tProfessionSpecsQueryRes>(
    `${BASE}/professionSpecs`,
    {
      params,
      // react-query handles the cache on client
      cache: IS_SERVER ? specsCache : false,
    },
  );
  return data;
};
const taskEditor = async (params: { master: string }) => {
  const { data } = await get<tTaskEditorQueryRes>(`${BASE}/taskEditor`, {
    params,
    cache: false,
  });
  return data;
};

const aggrTasks1 = async (params: tAggrTasks1QueryArgs) => {
  const { data } = await get(`${BASE}/aggr/businessTasks1`, {
    params,
    cache: false,
  });
  return data;
};

const bookingScreen = async (params: { master: string }) => {
  const { data } = await get<tBookingScreenQueryRes>(`${BASE}/bookingScreen`, {
    params,
    cache: false,
  });
  return data;
};
const taskPayoutScreen = async (params: { task: string }) => {
  const { data } = await get<tTaskPayoutScreenQueryRes>(
    `${BASE}/taskPayoutScreen`,
    {
      params,
      cache: false,
    },
  );
  return data;
};

export const QueriesAPI = {
  scheduler,
  professionSpecs,
  taskEditor,
  aggrTasks1,
  bookingScreen,
  taskPayoutScreen,
};
